module.exports = __webpack_public_path__ + "images/bannerES-a8f8aa93a42d742a207300ceddd6cdae.jpg";